module.exports = __webpack_public_path__ + "img/cost-o.dd868c7b.svg";